<template>
  <h2 class="leading-lg text-base font-bold" data-test="TH2">
    <slot />
  </h2>
</template>
